// extracted by mini-css-extract-plugin
export default {"scrollbarTrack":"#f1f1f1","scrollbar":"#c5c5c5"};